import { isDefined } from 'helpers/typeGuard'
import { Field } from 'types'

export function isMetricField<RecordType>(column: Field<RecordType>): boolean {
    if (isDefined(column.treatAsMetric)) {
        return column.treatAsMetric
    }

    return !!column.metricOptions
}
